import { PROXY_BASE } from '../config/apiConfig';

const TOKEN_KEY = 'bullivo_session_token';
const REFRESH_THRESHOLD_MS = 24 * 60 * 60 * 1000; // refresh wenn <24h übrig

function parseExpiry(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp ? payload.exp * 1000 : 0;
  } catch {
    return 0;
  }
}

function isTokenFresh(token) {
  const exp = parseExpiry(token);
  return exp > Date.now() + REFRESH_THRESHOLD_MS;
}

async function fetchNewToken() {
  const res = await fetch(`${PROXY_BASE}/api/auth/session`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  });
  if (!res.ok) throw new Error(`auth/session ${res.status}`);
  const { token } = await res.json();
  return token;
}

let _pending = null;

export async function getSessionToken() {
  const stored = localStorage.getItem(TOKEN_KEY);
  if (stored && isTokenFresh(stored)) return stored;

  // Dedupliziere parallele Calls
  if (!_pending) {
    _pending = fetchNewToken()
      .then(token => {
        localStorage.setItem(TOKEN_KEY, token);
        return token;
      })
      .finally(() => { _pending = null; });
  }
  return _pending;
}

export async function getAuthHeaders() {
  const token = await getSessionToken();
  return { Authorization: `Bearer ${token}` };
}
